import { createService } from '@betty/toolkit/api';
import {
  CustomerTokenSchema,
  SessionVariablesSchema,
} from './ChatService.schemas';

export default createService({
  getCustomerToken: {
    method: 'GET',
    url: ({ userId }: { userId: string }) =>
      `/livechat/${userId}/customerToken`,
    responseSchema: CustomerTokenSchema,
  },
  updateSessionVariables: {
    method: 'POST',
    url: ({ userId }: { userId: string }) =>
      `/livechat/${userId}/sessionVariables`,
    responseSchema: SessionVariablesSchema,
  },
});
